import React from 'react';
import { IFormItem } from '../RegistrationFormTypes';
import { RegistrationFormItems } from '../RegistrationFormItems';
import { Translate } from '@above-the-treeline/localization';

type ResetPasswordFormProps = {
	getFormItem: (item: IFormItem, substituteLabel?: JSX.Element) => void;
};

export default function ResetPasswordForm({
	getFormItem,
}: ResetPasswordFormProps) {
	return (
		<>
			{getFormItem(
				RegistrationFormItems.Password,
				<Translate id="new_password" />,
			)}
			{getFormItem(
				RegistrationFormItems.ConfirmPassword,
				<Translate id="new_password_confirm" />,
			)}
			{getFormItem(
				RegistrationFormItems.CurrentPassword,
				<Translate id="enter_current_password" />,
			)}
		</>
	);
}
